import styled from 'styled-components'
import { BaseInput, BaseMaskedInput } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const MaskedInput = styled(BaseMaskedInput)`
  width: 100%;
  margin: 0px 5px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  align-self: center;
`;

export const SubTitle = styled(Title)`
  font-size: 16px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled.label`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  line-height: 16px;
  margin-top: 3px;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
